import {Component, Input, OnDestroy, OnInit} from "@angular/core";
import {
  Aangifte,
  AangifteBerekening,
  AangifteRapport, BokkzAlgDataService,
  BokkzIbDataService, Box1Berekening,
  IncomeTaxEntity, OpbouwInkomenBox1, OpbouwLoon, SpecificatieLoon
} from "@snelstart-ventures/fiscaal/domain-logic";
import {BehaviorSubject, combineLatest, filter, Subscription} from "rxjs";
import {AbstractControl, FormBuilder, FormControl, FormGroup} from "@angular/forms";
import {Router} from "@angular/router";
import { SharedUiFormControlsModule } from '@snelstart/ui-form-controls';
import { CommonModule } from '@angular/common';
import { SharedUiDetailsModule } from '@snelstart/ui-details';
import { SharedUiAlertModule } from '@snelstart/ui-alert';

@Component({
  selector: 'snelstart-venture-fiscaal-feature-box1-belastbaar-loon',
  templateUrl: './box1-belastbaar-loon.component.html',
  styleUrls: ['./box1-belastbaar-loon.component.scss'],
    imports: [
        SharedUiFormControlsModule,
        CommonModule,
        SharedUiDetailsModule,
        SharedUiAlertModule
    ]
})
export class Box1BelastbaarLoonComponent implements OnInit, OnDestroy {
    private routerSubscription: Subscription | undefined;
    private incomeTaxEntitySubscription: Subscription | undefined;
    private clientEntitySubscription: Subscription | undefined;
    private isDefAangifteSubscription: Subscription | undefined;
    private isSaving = false;
    aangifte = {} as Aangifte;
    public incomeTaxEntity = {} as IncomeTaxEntity;

    @Input() partner = new BehaviorSubject<boolean>(false);
    public partnerBoolean = false;

    aangifteRapport = {} as AangifteRapport;
    partnerRapport = {} as AangifteRapport;
    berekening = {} as AangifteBerekening;
    partnerBerekening = {} as AangifteBerekening;

    public isDefAangifte = {} as boolean;

    specLoonFormGroup = this.fb.group<AangifteRapport>({});
    specLoon = {} as AangifteRapport;
    berekeningBox1FormGroup = this.fb.group<AangifteBerekening>({});

    constructor(public dataService: BokkzIbDataService, public dataAlgService: BokkzAlgDataService, private router: Router, private fb: FormBuilder) {
        this.specLoonFormGroup = this.fb.group<AangifteRapport>(({
            specificatieLoon: this.fb.group<SpecificatieLoon>(({
                opbouw: this.fb.group<OpbouwLoon>(({
                    belastbaarloon: null as unknown as number,
                    loonUitTegenwoordigeDienstbetrekking: null as unknown as number,
                    loonUitTegenwoordigeDienstbetrekkingBuitenland: null as unknown as number,
                    loonUitTegenwoordigeDienstbetrekkingInternationaleOrganisatie: null as unknown as number,
                    loonUitVroegereDienstbetrekking: null as unknown as number,
                    loonUitVroegereDienstbetrekkingBuitenland: null as unknown as number,
                    loonUitVroegereDienstbetrekkingInternationaleOrganisatie: null as unknown as number,
                    reisaftrekOpenbaarVervoer: null as unknown as number,
                    vergoedingReisaftrek: null as unknown as number,
                    totaalToegepasteArbeidskorting: null as unknown as number,
                } as OpbouwLoon))
            } as SpecificatieLoon))
        } as AangifteRapport))
        this.berekeningBox1FormGroup = this.fb.group<AangifteBerekening>(({
            box1: this.fb.group<Box1Berekening>(({
                opbouwInkomen: this.fb.group<OpbouwInkomenBox1>(({
                    belastbaarloon: null as unknown as number,
                } as OpbouwInkomenBox1)),
            } as Box1Berekening)),
        } as AangifteBerekening))
    }

    public ngOnInit(): void {
        this.isDefAangifteSubscription = this.dataService.isDefAangifte.subscribe((isDefAangifte) => {
            this.isDefAangifte = isDefAangifte;
        });
        combineLatest([this.dataService.incomeTaxEntity,
            this.dataService.aangifteBerekening,
            this.dataService.partnerAangifteRapport,
            this.dataService.aangifteRapport,
            this.partner
        ]).subscribe(
            ([incomeTaxEntity, aangifteBerekening, partnerRapport, aangifteRapport, partner]) => {
                this.specLoonFormGroup.reset();
                this.berekeningBox1FormGroup.reset();
                this.berekening = aangifteBerekening;
                if (aangifteBerekening.partnerBerekening) {
                  this.partnerBerekening=aangifteBerekening.partnerBerekening;
                }
                this.aangifteRapport = aangifteRapport;
                this.partnerRapport = partnerRapport;
                this.partnerBoolean = partner;
                if (this.partnerBoolean) {
                    this.specLoon = this.partnerRapport;
                  if (this.berekening.partnerBerekening) {
                        this.berekeningBox1FormGroup.reset();
                        this.berekeningBox1FormGroup.patchValue(this.partnerBerekening);
                    }
                    if (incomeTaxEntity.aangifte) {
                        const aangifte = incomeTaxEntity.aangifte as Aangifte;
                        this.aangifte = aangifte;
                        this.updateForm();
                        this.disableFormGroup(this.specLoonFormGroup);
                        this.disableFormGroup(this.berekeningBox1FormGroup);
                    }
                } else {
                  this.specLoon = this.aangifteRapport;
                  if (this.berekening) {
                        this.berekeningBox1FormGroup.reset();
                        this.berekeningBox1FormGroup.patchValue(this.berekening);
                    }
                    if (incomeTaxEntity.aangifte) {
                        const aangifte = incomeTaxEntity.aangifte as Aangifte;
                        this.aangifte = aangifte;
                        this.updateForm();
                        this.disableFormGroup(this.specLoonFormGroup);
                        this.disableFormGroup(this.berekeningBox1FormGroup);
                    }
                }
            }
        );
    }

    ngOnDestroy(): void {
        if (this.incomeTaxEntitySubscription) {
            this.incomeTaxEntitySubscription.unsubscribe(); // Unsubscribe from income tax entity
        }
        if (this.isDefAangifteSubscription) {
            this.isDefAangifteSubscription.unsubscribe();
        }
    }

    private updateForm() {
        if (this.partnerBoolean) {
            this.specLoon = this.partnerRapport;
            this.specLoonFormGroup.patchValue(this.partnerRapport);
            this.berekeningBox1FormGroup.patchValue(this.partnerBerekening)
        } else {
            this.specLoon = this.aangifteRapport;
            this.specLoonFormGroup.patchValue(this.aangifteRapport);
            this.berekeningBox1FormGroup.patchValue(this.berekening);
        }
    }

    disableFormGroup(formGroup: FormGroup | AbstractControl): void {
        if (formGroup instanceof FormGroup) {
            Object.keys(formGroup.controls).forEach((key) => {
                const control = formGroup.get(key);
                if (control instanceof FormControl) {
                    control.disable();
                } else if (control instanceof FormGroup) {
                    this.disableFormGroup(control);
                }
            });
        }
    }

    public heeftLoon(): boolean {
        if (this.partnerBoolean) {
            return !!(this.aangifte &&
                this.aangifte.partnerAangifte &&
                this.aangifte.partnerAangifte.box1 &&
                this.aangifte.partnerAangifte.box1.belastbaarLoon &&
                ((this.aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking &&
                        this.aangifte.partnerAangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking &&
                        this.aangifte.partnerAangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.belastbaarLoon.loonUitBuitenlandseDienstbetrekkingOfPensioen &&
                        this.aangifte.partnerAangifte.box1.belastbaarLoon.loonUitBuitenlandseDienstbetrekkingOfPensioen.length > 0) ||
                    (this.aangifte.partnerAangifte.box1.belastbaarLoon.vrijgesteldLoonInternationaleOrganisatie &&
                        this.aangifte.partnerAangifte.box1.belastbaarLoon.vrijgesteldLoonInternationaleOrganisatie.length > 0)));
        } else {
            return !!(this.aangifte &&
                this.aangifte.box1 &&
                this.aangifte.box1.belastbaarLoon &&
                ((this.aangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking &&
                        this.aangifte.box1.belastbaarLoon.loonUitTegenwoordigeDienstbetrekking.length > 0) ||
                    (this.aangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking &&
                        this.aangifte.box1.belastbaarLoon.loonUitVroegereDienstbetrekking.length > 0) ||
                    (this.aangifte.box1.belastbaarLoon.loonUitBuitenlandseDienstbetrekkingOfPensioen &&
                        this.aangifte.box1.belastbaarLoon.loonUitBuitenlandseDienstbetrekkingOfPensioen.length > 0) ||
                    (this.aangifte.box1.belastbaarLoon.vrijgesteldLoonInternationaleOrganisatie &&
                        this.aangifte.box1.belastbaarLoon.vrijgesteldLoonInternationaleOrganisatie.length > 0)));
        }
    }
}
